<template>
  <netvs-icon v-if="$store.state.expert" :size="size" icon="expert_feature"></netvs-icon>
</template>

<script>

export default {
  name: 'netvs-expert-marker',
  props: {
    size: {
      type: String,
      default() {
        return null
      }
    }
  }
}
</script>

<style scoped>

</style>
